import { createElement } from "react";
import { IconInfoOutline } from "@humansignal/icons";
import { Tooltip } from "@humansignal/ui";
import { cn } from "../../../../utils/bem";
import "./Label.prefix.css";
import { clsx } from "clsx";
/** @deprecated - needs to be replaced with @humansignal/ui Label - visualizes differently currently */
const Label = ({
  text,
  children,
  required,
  placement,
  description,
  footer,
  size,
  large,
  style,
  simple,
  flat,
  className,
  tooltip,
  tooltipIcon,
}) => {
  const rootClass = cn("label-ls");
  const classList = [rootClass.toClassName()];
  const tagName = simple ? "div" : "label";
  const mods = {
    size,
    large,
    flat,
    placement,
    withDescription: !!description,
    withFooter: !!footer,
    empty: !children,
  };

  classList.push(rootClass.mod(mods).toClassName());
  const rootProps = {
    className: clsx(classList, className),
    style: style,
  };

  if (required) {
    rootProps["data-required"] = true;
  }

  // Radio / checkbox / toggle labels (placement="right") keep their
  // description inline — it describes the option. Field labels (top) route
  // the description into an (i) tooltip so long help doesn't bloat the form.
  const inlineDescription = placement === "right";

  return createElement(
    tagName,
    rootProps,
    <>
      <div className={rootClass.elem("text").toClassName()}>
        <div className={rootClass.elem("content").toClassName()}>
          <div className={rootClass.elem("label").toClassName()}>
            <span>{text}</span>
            {(tooltip || (description && !inlineDescription)) && (
              <Tooltip title={<div className={rootClass.elem("tip").toClassName()}>{tooltip || description}</div>}>
                <button
                  type="button"
                  className={rootClass.elem("info").toClassName()}
                  aria-label="More information"
                  onClick={(e) => e.preventDefault()}
                >
                  {tooltipIcon ? tooltipIcon : <IconInfoOutline />}
                </button>
              </Tooltip>
            )}
          </div>
        </div>
      </div>
      <div className={rootClass.elem("field").toClassName()}>{children}</div>
      {description && inlineDescription && (
        <div className={rootClass.elem("description").toClassName()}>{description}</div>
      )}
      {footer && <div className={rootClass.elem("footer").toClassName()}>{footer}</div>}
    </>,
  );
};

export default Label;
